export default class BaseRepository {
    constructor() {
        this.baseuri = 'https://timetrackingserver.bermuda-network.org';
        this.user = 'manuel';
        this.password = 'lingi';
        this.timeout = 2000;
        this.headers = {
            'Authorization': `Basic ${btoa(`${this.user}:${this.password}`)}`
        };
    }

    _timeout(ms, promise) {
        return new Promise((resolve, reject) => {
            setTimeout(function() {
                reject(new Error("Timeout"))
            }, ms);

            promise.then(resolve, reject);
        });
    }

    async _requestWithTimeoutAsync(method, uri) {
        let response = await this._timeout(this.timeout, fetch(`${this.baseuri}${uri}`, {
            method: method,
            headers: this.headers,
            mode: 'cors',
            cache: 'default'
        }).catch((error) => {
            console.log('Connection Error: ', error);
        })).catch((error) => {
            console.log('Timeout Error: ', error);
        });

        if (response === undefined) {
            return undefined;
        }

        if (!response.ok) {
            throw Error(response.statusText);
        }

        return response;
    }
}



// WEBPACK FOOTER //
// ./src/data/BaseRepository.js